import copy from 'copy-to-clipboard'
import { useMessage } from './useMessage'

export default function useCopyToClipboard() {
  const { success, error } = useMessage()

  function handleCopy(text: string | number | unknown) {
    if (typeof text === 'string' || typeof text === 'number') {
      copy(text.toString())
      copy(text.toString())
      success('Данные скопированы в буфер обмена', 'Скопировано')
    } else {
      error(
        `Невозможно скопировать тип ${typeof text} в буфер обмена, должен быть строкой или числом.`,
        'Ошибка',
      )
    }
  }

  return handleCopy
}
